import './RAProjectionChartCustomTick.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { YEARS, YEARS_INITIALS } from 'constants/RAConstants/RAProjectionChartCustomTick';
import { isMobile } from 'utilities/browser';

class RAProjectionChartCustomTick extends React.Component {
    constructor(props) {
        super(props);

        this.yearsFormatter = this.yearsFormatter.bind(this);
    }

    yearsFormatter(tick) {
        const { years } = this.props;

        return isMobile() ? YEARS_INITIALS[years][tick] : YEARS[years][tick];
    }

    render() {
        const { payload, x, y, disabled } = this.props;
        const value = this.yearsFormatter(payload.value);
        const borderColor = disabled ? '#E3E9E9' : '#546E7A';
        const textColor = disabled ? '#E3E9E9' : '#69788C';
        let xCorrection = 0;

        if (isMobile() && payload.value !== 0) {
            if (payload.value !== 11 && payload.value !== 13 && payload.value !== 21) {
                xCorrection = 0;
            } else {
                xCorrection = 1;
            }
        }

        const widthButton = isMobile() ? '40' : '50';
        const buttonXCorrection = isMobile() ? 5 : 0;

        if (payload.value === 0) {
            return (
                <g>
                    <rect
                        x={x - 25}
                        y={y - 3}
                        width={widthButton}
                        height="27"
                        rx="15"
                        ry="15"
                        stroke={borderColor}
                        fill="none"
                    />
                    <text
                        x={x - buttonXCorrection}
                        y={y + 16}
                        fill={textColor}
                        textAnchor="middle"
                        className="ra-projection-custom-tick__button"
                    >
                        {value}
                    </text>
                </g>
            );
        }
        if (value) {
            return (
                <text
                    x={x - xCorrection}
                    y={y + 16}
                    fill={textColor}
                    textAnchor="middle"
                    className="ra-projection-custom-tick__date"
                >
                    {value}
                </text>
            );
        }

        return null;
    }
}

RAProjectionChartCustomTick.propTypes = {
    disabled: PropTypes.bool.isRequired,
    payload: PropTypes.object,
    x: PropTypes.number,
    y: PropTypes.number,
    years: PropTypes.number.isRequired,
};

module.exports = RAProjectionChartCustomTick;
